import { Wallet, Gem, MessagesSquare, ArrowUpRight } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";
import { scrollToId } from "@/lib/site";

const PILLARS = [
  {
    icon: Wallet,
    t: "Flat-Rate Packages",
    d: "Scoped to your square footage and locked before work begins — no surprise invoices, no moving targets.",
    testid: "package-card-flat-rate",
  },
  {
    icon: Gem,
    t: "Optional Upgrades",
    d: "Custom furniture and art sourcing, layered in only when you want them — bespoke pieces that finish the story.",
    testid: "package-card-upgrades",
  },
  {
    icon: MessagesSquare,
    t: "Complimentary Consultation",
    d: "A personalized initial consultation session, on the house. Walk us through your space; we'll map what's possible.",
    testid: "complimentary-consultation-banner",
  },
];

export default function Engagement() {
  return (
    <section id="services" data-testid="packages-pricing-section" className="py-24 lg:py-32 bg-sand">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <FadeUp>
          <Eyebrow>Engagement</Eyebrow>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink mt-5 max-w-2xl leading-[1.05]">
            Simple, transparent, on your terms
          </h2>
        </FadeUp>

        <div className="grid lg:grid-cols-3 gap-4 mt-16">
          {PILLARS.map((p, i) => (
            <FadeUp key={p.t} delay={i * 0.08}>
              <div
                data-testid={p.testid}
                className="group bg-cream border border-hairline p-9 lg:p-10 h-full hover:shadow-xl hover:-translate-y-1 hover:border-brass/50 transition-all duration-300"
              >
                <div className="h-12 w-12 border border-brass/40 flex items-center justify-center group-hover:bg-brass/10 transition-colors duration-300">
                  <p.icon size={20} className="text-brass-deep" />
                </div>
                <h3 className="font-serif text-2xl text-ink mt-7">{p.t}</h3>
                <p className="text-sm leading-relaxed text-taupe mt-4">{p.d}</p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.1}>
          <div data-testid="package-upgrades-list" className="bg-ink text-cream mt-4 p-9 lg:p-12 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div>
              <p className="font-serif text-2xl lg:text-3xl leading-snug max-w-xl">
                Begin your project with a complimentary consultation.
              </p>
              <p className="text-sm text-cream/55 mt-3">
                Residential, commercial or hospitality — bring us the space, we'll bring it home.
              </p>
            </div>
            <button
              data-testid="packages-cta-button"
              onClick={() => scrollToId("contact")}
              className="group shrink-0 bg-brass text-ink px-8 py-4 text-sm tracking-wide flex items-center gap-2 hover:bg-cream transition-colors duration-300"
            >
              Start Your Project
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
